import { PositionActionTypes } from './PositionContext';

export const setUserChipStackPosition = (seatNumber: number, position: { x: number; y: number }) => ({
  type: PositionActionTypes.SET_CHIP_STACK_POSITION,
  payload: { seatNumber, position },
});

export const setPotPosition = (position: { x: number; y: number }) => ({
  type: PositionActionTypes.SET_POT_POSITION,
  payload: position,
});

export const setUserChipRef = (seatNumber: number, ref: React.RefObject<HTMLDivElement>) => ({
  type: PositionActionTypes.SET_USER_CHIP_REF,
  payload: { seatNumber, ref },
});

export const setPotRef = (ref: React.RefObject<HTMLDivElement>) => ({
  type: PositionActionTypes.SET_POT_REF,
  payload: ref,
});
